export const ROUTE_HOME = '/';

export const ROUTE_TVBET = '/grytv';

export const ROUTE_OFFERS = '/offers';
export const ROUTE_ABOUT = '/about';
export const ROUTE_TERMSANDCONDITIONS = '/terms-and-conditions';
export const ROUTE_PRIVACYPOLICY = '/privacy_policy';
export const ROUTE_RESPONSIBLEGAMING = '/responsible-gaming';
export const ROUTE_USERFEEDBACK = '/user-feedback';
export const ROUTE_WE_SPIN = '/we-spin';
export const ROUTE_AFFILIATE = '/affiliate';
// account related routes
export const ROUTE_ACCOUNT = '/account';
// export const ROUTE_ACCOUNT =
// 	'/account/:emailVerificationStatus(email-already-verified|email-verification-failed|email-verification-success)?';
export const ROUTE_ACCOUNT_DEPOSIT = '/account/deposit';
export const ROUTE_ACCOUNT_WITHDRAW = '/account/withdraw';
export const ROUTE_ACCOUNT_PENDING_WITHDRAW = '/account/pendingwithdrawals';
export const ROUTE_ACCOUNT_MY_LIMITS = '/account/my-limits';
export const ROUTE_ACCOUNT_REALITY_CHECK = '/account/reality-check-set-time-limit';
export const ROUTE_ACCOUNT_TRANSACTION_HISTORY = '/account/transaction-history';
export const ROUTE_ACCOUNT_NOTIFICATIONS = '/account/my-notifications';
export const ROUTE_ACCOUNT_SOURCE_OF_WEALTH = '/account/sow';
export const ROUTE_ACCOUNT_WEB_PUSH_BACKDOOR = '/account/web-push-backdoor';
export const ROUTE_PAYMENT_RESULT = '/payment/result';

export const ROUTE_ACCOUNT_DEPOSIT_INTERCEPTOR_NATIVE = '/account/native-interceptor/deposit';

// Risk profile
export const ROUTE_ACCOUNT_RISK_PROFILE = '/account/risk-profile';
export const ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS = `${ROUTE_ACCOUNT_RISK_PROFILE}/gaming-habits`;
export const ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_PLAYER_BEHAVIOR =
	'/account/risk-profile/gaming-habits/player-behavior';
export const ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_GAME_TYPES = '/account/risk-profile/gaming-habits/game-types';
export const ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_SELF_ASSESSMENT_RESULT =
	'/account/risk-profile/gaming-habits/self-assessment-result';
export const ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_MESSAGES_MENTOR =
	'/account/risk-profile/gaming-habits/messages-mentor';
export const ROUTE_ACCOUNT_RISK_PROFILE_GAMING_HABITS_SELF_ASSESSMENT =
	'/account/risk-profile/gaming-habits/self-assessment';

export const ROUTE_ACCOUNT_LIMITS_ACTIVITY = '/account/player-limits-activity';
export const ROUTE_ACCOUNT_WALLET = '/account/wallet';
export const ROUTE_ACCOUNT_EMAIL = '/account/email';
export const ROUTE_ACCOUNT_PHONE = '/account/mobile';
export const ROUTE_ACCOUNT_UPLOAD = '/account/upload';
export const ROUTE_ACCOUNT_MYSETTINGS = '/account/mysettings';

export const ROUTE_ACCOUNT_SETTINGS = '/account/settings';

export const ROUTE_ACCOUNT_BONUS_CODE = '/account/bonuscode';
export const ROUTE_ACCOUNT_MY_ACTIVITIES = '/account/my-activities';
export const ROUTE_ACCOUNT_COMPLETE_VERIFICATIONS = '/account/complete-verifications';
export const ROUTE_AUTH_RES_GAMING = '/auth-res-gaming';
export const ROUTE_LOGIN = '/login';
export const ROUTE_LOGIN_GUEST = '/login/guest';
export const ROUTE_PLAY_AS_GUEST = '/play-as-guest';

export const ROUTE_REGISTER = '/register';
export const ROUTE_RESET_PASSWORD = '/reset-password-start';
export const ROUTE_RESET_PASSWORD_EMAIL = '/reset-password-email';
export const ROUTE_RESET_PASSWORD_PHONE = '/reset-password-phone';
export const ROUTE_RESET_PASSWORD_CODE = '/reset-password-code';
export const ROUTE_RESET_PASSWORD_WELCOME = '/reset-password-welcome';
export const ROUTE_RESET_PASSWORD_DOB_VERIFICATION = '/reset-password-dob-verification';
export const ROUTE_NEW_PASSWORD = '/new-password';
export const ROUTE_BANKID = '/bankid';
export const ROUTE_INACTIVE_SESSION = '/session-inactive';
export const ROUTE_GUEST_DEPOSIT_LOGIN = '/guest-deposit-login';
export const ROUTE_GUEST_DEPOSIT_LOGIN_RESULT = '/guest-deposit-login-result';
export const ROUTE_GUEST_INSTANT_DEPOSIT = '/guest-instant-deposit-page';
export const ROUTE_GUEST_LOGIN_VERIFY_ACCOUNT = '/guest-login-verify-account';
export const ROUTE_EXTERNAL_LOGIN = '/external-login';
export const ROUTE_EXTERNAL_REQUEST = '/external-request';
export const ROUTE_CAMPAIGN_REGISTER = '/campaign-registration';
export const ROUTE_AUTHENTICATION = '/authentication';
export const ROUTE_PLAY_NOW = '/step';
export const ROUTE_PLAY_NOW_BANKID = '/step/bankid';
export const ROUTE_PLAY_NOW_DGA = '/step/providers';
export const ROUTE_RETURN_PATH_DEPOSIT = '/step/deposit-complete';
export const ROUTE_RETURN_PATH_REGISTRATION = '/step/registration-complete';
export const ROUTE_WELCOME = '/welcome';
export const ROUTE_TEMP_ACCOUNT = '/temporary-account';

export const ROUTE_GLOBAL = '/global';
export const ROUTE_INFO = '/info';
export const ROUTE_HUB = '/hub';

export const ROUTE_BONUS = '/bonus';
export const ROUTE_MOBILE_QUICK_DEPOSIT = 'mobile-quick-deposit';

// Virtuals
export const ROUTE_VIRTUALS = '/virtuals';

export const ROUTE_INSPIRED = '/virtuals/inspired';
// Highlight games
export const ROUTE_HIGHLIGHT_GAMES = '/virtuals/retrobet';
export const ROUTE_HIGHLIGHT_GAMES_BET_HISTORY = `${ROUTE_HIGHLIGHT_GAMES}/bet-history`;
export const ROUTE_HIGHLIGHT_GAMES_EVENT_MARKETS_BASE = `${ROUTE_HIGHLIGHT_GAMES}/event`;
export const ROUTE_HIGHLIGHT_GAMES_EVENT_MARKETS = `${ROUTE_HIGHLIGHT_GAMES_EVENT_MARKETS_BASE}/:eventId`;
export const ROUTE_HIGHLIGHT_GAMES_GAME_RULES = `${ROUTE_HIGHLIGHT_GAMES}/game-rules`;

// Sportsbook
export const ROUTE_SPORTSBOOK = '/sportsbook';
export const ROUTE_LIVEBETTING = '/live-betting';
export const ROUTE_SPORTS = '/sports'; // Redirect only

export const ROUTE_SPORTSBOOK_SEARCH_PAGE = `${ROUTE_SPORTSBOOK}/search`;
export const ROUTE_SPORTSBOOK_SPORTS_PAGE = `${ROUTE_SPORTSBOOK}/sports`;
export const ROUTE_SPORTSBOOK_SPORT_PAGE = `${ROUTE_SPORTSBOOK}/sports/:sportIdWithSlug`;
export const ROUTE_SPORTSBOOK_SPORT_PAGE_TAB = `${ROUTE_SPORTSBOOK_SPORT_PAGE}/:tab`;
export const ROUTE_SPORTSBOOK_SPORT_PAGE_UPCOMING_DAY_TAB = `${ROUTE_SPORTSBOOK_SPORT_PAGE_TAB}/:day`;

export const ROUTE_SPORTSBOOK_MY_BETS = `${ROUTE_SPORTSBOOK}/my-bets`;
export const ROUTE_SPORTSBOOK_MY_BETS_TAB = `${ROUTE_SPORTSBOOK_MY_BETS}/:tab`;
export const ROUTE_SPORTSBOOK_MY_BETS_SETTLED = `${ROUTE_SPORTSBOOK_MY_BETS}/settled`;
export const ROUTE_SPORTSBOOK_MY_BETS_OPEN = `${ROUTE_SPORTSBOOK_MY_BETS}/open`;

export const ROUTE_SPORTSBOOK_LEAGUES = `${ROUTE_SPORTSBOOK_SPORT_PAGE}/leagues`;
export const ROUTE_SPORTSBOOK_LEAGUE_PAGE = `${ROUTE_SPORTSBOOK_LEAGUES}/:leagueIdWithSlug`;
export const ROUTE_SPORTSBOOK_FLAT_LEAGUE_PAGE = `${ROUTE_SPORTSBOOK}/leagues/:leagueIdWithSlug`;
export const ROUTE_SPORTSBOOK_LEAGUE_PAGE_TAB = `${ROUTE_SPORTSBOOK_LEAGUE_PAGE}/:tab`;
export const ROUTE_SPORTSBOOK_LEAGUE_PAGE_OUTRIGHTS_TAB = `${ROUTE_SPORTSBOOK_LEAGUE_PAGE}/outrights`;

export const ROUTE_SPORTSBOOK_BROWSE = `${ROUTE_SPORTSBOOK}/browse`;
export const ROUTE_SPORTSBOOK_BROWSE_TAB = `${ROUTE_SPORTSBOOK_BROWSE}/:tab`;

export const ROUTE_SPORTSBOOK_EXPLORE_PAGE = `${ROUTE_SPORTSBOOK}`;
export const ROUTE_SPORTSBOOK_LIVE_PAGE = `${ROUTE_SPORTSBOOK}/live`;
export const ROUTE_SPORTSBOOK_LIVE_PAGE_SPORTS_TAB = `${ROUTE_SPORTSBOOK_LIVE_PAGE}/sport`;
export const ROUTE_SPORTSBOOK_LIVE_PAGE_SPORT_TAB = `${ROUTE_SPORTSBOOK_LIVE_PAGE_SPORTS_TAB}/:sportIdWithSlug`;

export const ROUTE_SPORTSBOOK_EVENTS = `${ROUTE_SPORTSBOOK_LEAGUE_PAGE}/events`;
export const ROUTE_SPORTSBOOK_EVENT_PAGE = `${ROUTE_SPORTSBOOK_EVENTS}/:eventIdWithSlug`;
export const ROUTE_SPORTSBOOK_FLAT_EVENTS = `${ROUTE_SPORTSBOOK}/events`;
export const ROUTE_SPORTSBOOK_FLAT_EVENT = `${ROUTE_SPORTSBOOK}/events/:eventIdWithSlug`;

export const ROUTE_APP_BOOT = '/app-boot';

export const SPORTSBOOK_ROUTES = [
	ROUTE_SPORTSBOOK,
	ROUTE_LIVEBETTING,
	ROUTE_SPORTSBOOK_SPORTS_PAGE,
	ROUTE_SPORTSBOOK_SPORT_PAGE,
	ROUTE_SPORTSBOOK_EVENTS,
	ROUTE_SPORTSBOOK_MY_BETS,
	ROUTE_SPORTSBOOK_LEAGUES,
	ROUTE_SPORTSBOOK_LEAGUE_PAGE,
	ROUTE_SPORTSBOOK_BROWSE,
	ROUTE_SPORTSBOOK_LIVE_PAGE,
	ROUTE_SPORTSBOOK_EXPLORE_PAGE
];

// Marketplace
export const ROUTE_PROMOTIONS = '/promotions';
export const ROUTE_PROMOTIONS_THUNDERBITE = '/promotions/thunderbite';
export const ROUTE_PROMOTIONS_DETAIL = '/promotions-detail';
export const ROUTE_SHOP = '/shop';
export const ROUTE_CAMPAIGN = '/campaign';
export const ROUTE_THUNDERBITE = '/thunderbite';
export const ROUTE_SPLASH_TECH = '/splash-tech';
export const ROUTE_SHOP_DETAIL = '/shop-detail';
export const ROUTE_FREE_TO_PLAY = '/free-to-play';
export const ROUTE_FREE_TO_PLAY_DETAIL = '/free-to-play-detail';
export const ROUTE_FREE_TO_PLAY_CUSTOM = '/f2p';

export const ROUTE_COOKIE_POLICY = '/cookie-policy';

export const ROUTE_COMMUNICATIONS_NOTIFICATIONS = '/notifications';

export const ROUTE_FREEBET = '/freebet';
export const ROUTE_LEGAL_BETTING = '/legalny-bukmacher';
export const ROUTE_BETTING_TIPS = '/typy-bukmacherskie';
export const ROUTE_TAX = '/podatek-od-wygranej-i-stawki';

export const ROUTE_COMPLAINT_PROCEDURE = '/complaint-procedure';

// Account settings
export const ROUTE_ACCOUNT_SETTINGS_PERSONAL_INFORMATION = '/account/settings/personal-information';
export const ROUTE_ACCOUNT_SETTINGS_WE_SPIN_DISPLAY_NAME = '/account/settings/we-spin-display-name';
export const ROUTE_ACCOUNT_SETTINGS_WE_SPIN_NOTIFICATION = '/account/settings/we-spin-notification-opt-out';
export const ROUTE_ACCOUNT_SETTINGS_OTHER_SETTINGS = '/account/settings/other-settings';
export const ROUTE_ACCOUNT_SETTINGS_OTHER_SETTING_AUTO_WD = '/account/settings/other-settings/auto-withdrawals';
export const ROUTE_ACCOUNT_SETTINGS_CHANGE_PASSWORD = '/account/settings/change-password';
export const ROUTE_ACCOUNT_SETTINGS_TWO_FACTOR_AUTHENTICATION = '/account/settings/two-factor-authentication';
export const ROUTE_ACCOUNT_SETTINGS_CLOSE_ACCOUNT = '/account/settings/close-account';
export const ROUTE_ACCOUNT_SETTINGS_CLOSE_ACCOUNT_EXCLUSION_TIME = '/account/settings/close-account/exclusion-time';
export const ROUTE_ACCOUNT_SETTINGS_CLOSE_ACCOUNT_OASIS_REASON = '/account/settings/close-account/oasis-reason';
export const ROUTE_ACCOUNT_SETTINGS_CLOSE_ACCOUNT_FEEDBACK = '/account/settings/close-account/feedback';
export const ROUTE_ACCOUNT_SETTINGS_CLOSE_CATALOG = '/account/settings/close-catalog';
export const ROUTE_ACCOUNT_SETTINGS_CLOSE_CATALOG_CLOSE_ACCOUNT = '/account/settings/close-catalog/close-account';
export const ROUTE_ACCOUNT_SETTINGS_CLOSE_CATALOG_EXCLUSION_TIME = '/account/settings/close-catalog/exclusion-time';
export const ROUTE_ACCOUNT_SETTINGS_SELF_EXCLUSION = '/account/settings/self-exclusion';
export const ROUTE_ACCOUNT_SETTINGS_SUBSCRIPTIONS = '/account/settings/subscriptions';
export const ROUTE_VERIFICATION_POLAND = '/weryfikacja';
export const ROUTE_PAYMENTS = '/payments'; // old polish payment route
export const ROUTE_PAYMENTS_POLAND = '/platnosci'; // new polish payment route

export const ROUTE_SUPPORT = '/support';
export const ROUTE_SUPPORT_HUB = '/hub-support';
export const ROUTE_TERMS_CONDITIONS_SIDEBAR = '/terms-and-conditions-sidebar';
export const ROUTE_TERMS_CONDITIONS_BONUS_SIDEBAR = '/terms-and-conditions-bonus-sidebar';
export const ROUTE_PRIVACY_POLICY_SIDEBAR = '/privacy-policy-sidebar';
export const ROUTE_COOKIE_POLICY_SIDEBAR = '/cookie-policy-sidebar';
export const ROUTE_POINTS_FAQ = '/points-faq';
